(() => {
  let _physicalSnapshot = null;
  let _awaitingRemoval = false;

  async function snapshotPhysical() {
    try {
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(r => r.json());

      const map = new Map();
      (cart.items || [])
        .filter(i => i.vendor !== 'Textildruck-Service')
        .forEach(i => {
          if (!map.has(i.handle)) map.set(i.handle, new Set());
          map.get(i.handle).add(i.key);
        });
      _physicalSnapshot = map;
    } catch (e) {
      _physicalSnapshot = null;
    }
  }

  async function cleanupAfterRemove() {
    if (!_physicalSnapshot) return;
    const before = _physicalSnapshot;
    _physicalSnapshot = null;

    try {
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(r => r.json());

      const items = cart.items || [];

      const currPhysical = new Map();
      items
        .filter(i => i.vendor !== 'Textildruck-Service')
        .forEach(i => {
          if (!currPhysical.has(i.handle)) currPhysical.set(i.handle, new Set());
          currPhysical.get(i.handle).add(i.key);
        });

      const handlesWithRemovals = new Set();
      before.forEach((prevKeys, handle) => {
        const currKeys = currPhysical.get(handle) || new Set();
        if ([...prevKeys].some(k => !currKeys.has(k))) {
          handlesWithRemovals.add(handle);
        }
      });

      const physicalHandles = new Set(currPhysical.keys());

      const toRemoveIndices = items.reduce((acc, item, idx) => {
        if (item.vendor !== 'Textildruck-Service') return acc;
        const linked = item.properties?._LinkedToHandle;
        if (!linked) return acc;
        if (handlesWithRemovals.has(linked) || !physicalHandles.has(linked)) {
          acc.push(idx);
        }
        return acc;
      }, []).sort((a, b) => b - a); // descending — preserves line indices

      if (!toRemoveIndices.length) return;

      for (const idx of toRemoveIndices) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: idx + 1, quantity: 0 })
        });
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'batch-cleanup' });
      }
    } catch (e) {
      console.warn('[batch-cleanup]', e);
    }
  }

  function init() {
    // Capture state BEFORE the remove button removes the item
    document.addEventListener('click', (e) => {
      if (e.target.closest('cart-remove-button')) {
        snapshotPhysical();
        _awaitingRemoval = true;
      }
    }, true);

    // Run cleanup AFTER CartItems confirms the cart was updated
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'batch-cleanup') return;
        if (event?.source === 'cart-items' && _awaitingRemoval) {
          _awaitingRemoval = false;
          cleanupAfterRemove();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
